import { render, staticRenderFns } from "./ProjectContactLookupPopup.vue?vue&type=template&id=3f7889ec"
import script from "./ProjectContactLookupPopup.vue?vue&type=script&lang=ts"
export * from "./ProjectContactLookupPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports